import i18n from '@/i18n'
const dishesBtnStatus = {
  0: i18n._('下架'),
  1: i18n._('下架'),
  2: i18n._('上架'),
}

const dishesPutOnStatus = 1
const dishesPullOffStatus = 2
const dishesIsMustCode = 1

// 状态
const handleDishesStatus = {
  0: {
    describe: i18n._('全部'),
    handleCode: 2,
    btnTxt: i18n._('下架'),
  },
  1: {
    describe: i18n._('上架'),
    handleCode: 2,
    btnTxt: i18n._('下架'),
  },
  2: {
    describe: i18n._('下架'),
    handleCode: 1,
    btnTxt: i18n._('上架'),
  },
}

const dishesListEmptyText = i18n._('暂无菜品')
const searchEmptyText = i18n._('未搜索到相关菜品')

export const DINE_MENU_STATUS = {
  DEFAULT: -1,
  AUDIT_PENDING: 0,
  AUDIT_PASSED: 1,
  AUDIT_FAILED: 2,
}

export const FILE_SIZE_LIMIT = {
  DINE_MENU_IMG: {
    LIMIT_NUM: 20,
    LIMIT_SIZE: 20 * 1024 * 1024,
  },
  DINE_MENU_PDF: {
    LIMIT_NUM: 50,
    LIMIT_SIZE: 50 * 1024 * 1024,
  },
}
export const RELATION_TYPE = {
  OWNER: 1, // 自营
  FRANCHISEE: 2, // 加盟
}

export const MAX_STOCK = 9999

export default {
  dishesBtnStatus,
  dishesPutOnStatus,
  dishesPullOffStatus,
  dishesIsMustCode,
  handleDishesStatus,

  dishesListEmptyText,
  searchEmptyText,
}
